/* eslint-env browser */
import React, {
  useCallback, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import ClientSideConfigSelector from '../../../../recoil/cashout/ClientSideConfigSelector';
import IFrame from '../common/IFrame';
import useHttpRequest from '../../../api/HttpRequest';

function extractIframeSize(data) {
  const rawHeight = data?.TipaltiIframeInfo?.height;
  const height = Number.isFinite(Number(rawHeight)) ? Number(rawHeight) : null;

  return {
    height,
  };
}

function clampHeight(height, minHeight) {
  return `${Math.max(height, minHeight)}px`;
}

export default function CashoutOnboardingForm({
  title,
  payAccount,
  onClose,
}) {
  const httpRequest = useHttpRequest();
  const [iframeHeight, setIframeHeight] = useState('100%');
  const [onboardingLink, setOnboardingLink] = useState(null);
  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        paymentProvider,
        providers: {
          [paymentProvider]: {
            iframe: {
              dynamicScrollingEnabled = false,
              minHeight = 320,
            } = {},
          } = {},
        },
      } = {},
    } = {},
  } = config || {};

  const provider = payAccount?.provider;

  const onPostEvent = useCallback((evt) => {
    if (evt?.data?.caller !== 'PaymentDetails') {
      return;
    }

    const { height } = extractIframeSize(evt.data);
    if (height === null) {
      return;
    }

    const nextHeight = clampHeight(height, minHeight);
    setIframeHeight((currentHeight) => (currentHeight === nextHeight ? currentHeight : nextHeight));
  }, [minHeight]);

  useEffect(() => {
    if (!provider) {
      return;
    }

    const getOnboardingLink = async () => {
      try {
        const result = await httpRequest.send(`/web-payments/registration/${provider}/link`, {
          method: 'POST',
        });
        setOnboardingLink(result.registrationLink);
        console.log('Registration URL: ', result);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Unable to fetch Registration link', err);
      }
    };

    getOnboardingLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provider]);

  return (
    (dynamicScrollingEnabled ? (
      <IFrame
        title={title}
        url={onboardingLink || ''}
        height={iframeHeight}
        onClose={onClose}
        onPostEvent={onPostEvent}
      />
    ) : (
      <IFrame
        title={title}
        url={onboardingLink || ''}
        onClose={onClose}
      />
    ))
  );
}
CashoutOnboardingForm.propTypes = {
  title: PropTypes.string,
  payAccount: PropTypes.shape({
    provider: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};
CashoutOnboardingForm.defaultProps = {
  title: '',
};
